"use strict";
var lib_core = require("lib-core")
var PackageMetaData = require("./packageMetaData.js");
 
var BoxData = require("./../model3d/boxData.js");
var Model3DReference = require("./../model3d/model3DReference.js");

var lib_geometry = require("lib-geometry");

var PackageData = function (initializeNew) {
    this.makeObservableTreeNode();
    var self = this;

    this.metaData = this.value("metaData", true);
    this.footprintInstances  = this.list("footprintInstances", true);
    this.model3d = this.value("model3d", true);

    //false if the 3d model stored in data is created by IPC generator
    //true if 3d model is manually added to the data by the user by dragging/uploading a STEP file or adding from existing 3d models
    this.is3dModelUploadedManually = this.value("is3dModelUploadedManually", true);

    //parametric package data
    this.ipcParametricData = this.value("ipcParametricData", true);

    //this flag is used to check whether 3d model is in sync with persistent IPC data or not
    //false when 3d model generated using 3d model generator or package generator from IPC data
    //true when a new STEP file is uploaded and it replaces existing generated 3d model from IPC data or IPC data is updated without generating 3d model
    this.isIPCDataAnd3DModelOutOfSync = this.value("isIPCDataAnd3DModelOutOfSync", true);

    //flag to detect whether only 3d model is generated from IPC data or not
    //this is set to true when there is no IPC data and 3d model generator is selected
    this.isOnly3dModelGeneratedFromIPCParam = this.value("isOnly3dModelGeneratedFromIPCParam", true);

    //return true if IPC 3D package is generated but not saved yet
    this.hasIPCPreview = this.cachedFunction("hasIPCPreview",
        function () {
            return !self.is3dModelUploadedManually() && self.isIPCDataAnd3DModelOutOfSync();
        },
        [this.is3dModelUploadedManually, this.isIPCDataAnd3DModelOutOfSync]
    );

    this.isComplete = this.shadow("isComplete",
        function() {
            return this.footprintInstances.size() !== 0;
        }, null,
        [[this, this.onBubble]]
    );

    // on footprint add, may want to create the right sized box.
    this.footprintInstances.onAdd("initDefaultBox", function(index, instance){
        if(self.model3d() instanceof BoxData){
           // on initial footprint add, create default box size to bb of footprint
          if(this.size() == 1){
              self.resizeOrRemoveBox();
          } 
        }
    });

    this.model3d.onChange("changeModel3d", function (value, current) {
        if (value instanceof Model3DReference) {
            self.clearModel3dPositionInFootprintInstances();
        }
    })

    if (initializeNew) {
        var metaData = new PackageMetaData();
        metaData.name("New Package");
        metaData.summary("");
        metaData.description("");
        this.metaData(metaData);
        this.model3d(new BoxData(0, 0, 0));
    }
};

lib_core.mixin(PackageData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(PackageData, "PackageData");

module.exports = PackageData;

PackageData.prototype.calculateGeometryInfo = function(){
    return this.model3d().calculateGeometryInfo();
}

PackageData.prototype.resizeOrRemoveBox = function(){
    if(this.footprintInstances && this.footprintInstances.size() >= 1) {
        var fdata = this.footprintInstances.getOne();
        
        if(!fdata.boundingBox) return; // data is loading still
        
        var boundingBox = fdata.boundingBox();
        
        if(!boundingBox){
            this.model3d(null);
            return;
        }

        // default height to 0.1 mm as in Fusion
        var height = 100;

        this.model3d(new BoxData(
            boundingBox.width,
            boundingBox.height,
            height
        ) );

        var pos = new lib_geometry.Coord3d(
            boundingBox.x + boundingBox.width/2,
            boundingBox.y + boundingBox.height/2,
            0 );

        fdata.model3dPosition(pos);
        fdata.model3dRotation(new lib_geometry.Coord3d(0,0,0));

    }
}

PackageData.prototype.clearModel3dPositionInFootprintInstances = function() {
    if (this.footprintInstances) {
        this.footprintInstances.forEach(function(index, footprintInstance){
            if (!footprintInstance.boundingBox) return;

            const pos = new lib_geometry.Coord3d(0, 0, 0);
            footprintInstance.model3dPosition(pos);
        })
    }
}
 

